module.exports = __webpack_public_path__ + "static/media/VET.38a0cb64.svg";